<template>
  <!-- ホルター心電図解析結果入力詳細 -->
  <div id="HolterAnalysisResultDetail">
    <div id="container-center">
      <div class="switch-area">
        <b-switch class="englishSwitch" size="is-midium" v-model="isChangeEnglish">English</b-switch>
      </div>
      <div class="labelTitle lable">{{isChangeEnglish ? "Input Holter ECG analysis results": "ホルター心電図解析 解析結果入力"}}</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">{{isChangeEnglish ? "Back": "戻る"}}</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr><th>{{isChangeEnglish ? "Reception number": "受付番号"}}</th><td>{{data.receiptNumber}}<span v-if="data.depositMachineFlag" class="depo"/></td></tr>
            <tr><th>{{isChangeEnglish ? "Requested return date": "返却希望日"}}</th><td>{{data.returnDate}}</td></tr>
            <tr><th>{{isChangeEnglish ? "Analysis deadline": "解析期限"}}</th><td>{{data.analysisDeadline}}</td></tr>
            <tr>
              <th style="vertical-align:top;">{{isChangeEnglish ? "Reception notes": "受付備考"}}</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.note}}</td>
            </tr>
            <tr v-if="data.rejectHistory && data.rejectHistory.length > 0">
              <th>{{isChangeEnglish ? "Reject reason": "却下理由"}}</th>
              <td colspan="2">
                <table class="reject-reason-table">
                  <tr>
                    <th class="reject-date">{{isChangeEnglish ? "Date": "日時"}}</th>
                    <th>{{isChangeEnglish ? "Reason": "理由"}}</th>
                  </tr>
                  <tr v-for="reject in data.rejectHistory" :key="reject.value">
                    <td class="reject-date">{{ reject.completionDate }}</td>
                    <td>{{ reject.reason }}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr v-if="data.holterRequestId==null">
              <th>{{isChangeEnglish ? "Analysis method": "解析方法"}}</th>
              <td>{{data.analysisMethod | choiceFilter(analysisMethodList)}}</td>
            </tr>
            <tr v-if="data.holterRequestId!=null">
              <th>{{isChangeEnglish ? "Analysis method": "解析方法"}}</th>
              <td>ホルター心電図</td>
            </tr>
            <tr><th>{{isChangeEnglish ? "Examination date": "検査日"}}<span class="require" :class="{requireEnglish: isChangeEnglish}"/></th>
            <td v-if = "isHolterService()"><input type="date" style="width:200px;height: 27px;" class="edit" name="検査日" validate="required" v-model="data.inspectionDate" :max="yyyy_hyp_MM_hyp_dd(new Date())" /></td>
            <td v-if = "!isHolterService()"><input type="date" style="width:200px;height: 27px;" class="edit" name="検査日" validate="required" v-model="data.inspectionDate" :max="yyyy_hyp_MM_hyp_dd(new Date())" /></td></tr>
            <tr><th>CVHRI<span class="require" :class="{requireEnglish: isChangeEnglish}"/></th><td><input type="text" class="edit" :disabled="isCvhriNotCalcCheck" v-model="data.cvhri" name="CVHRI" :validate="`${isCvhriNotCalcCheck ? '':'required||double'}`"/></td></tr>
            <tr><th></th><td><b-checkbox style="width: 26px" v-model="isCvhriNotCalcCheck"></b-checkbox>{{isChangeEnglish ? "CVHRI not calculable": "CVHRI算出不可"}}</td></tr>
            <tr>
              <th>{{isChangeEnglish ? "AF Yes/No": "AFの有無"}}<span class="require" :class="{requireEnglish: isChangeEnglish}"/></th>
              <td>
                <div class="block edit" validate="radioRequire" name="AFの有無">
                  <b-radio class="td_radio" name="AFCheck"  v-model="data.af" native-value="2">{{isChangeEnglish ? "No": "無し"}}</b-radio>
                  <b-radio class="td_radio" name="AFCheck"  v-model="data.af" native-value="1">{{isChangeEnglish ? "Yes": "有り"}}</b-radio>
                </div>
              </td>
            </tr>
            <tr><th>{{isChangeEnglish ? "Memo": "メモ"}}</th><td><textarea maxlength="256" style="resize:vertical;max-width:100%;" v-model="data.memo"></textarea></td></tr>
            <tr>
              <th style="vertical-align:top;">{{isChangeEnglish ? "Upload file name": "アップロードファイル名"}}</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><span>{{uploadFileName}}<b-button class="clipbordcopy is-primary" @click="clipboardCopy()">{{isChangeEnglish ? "Copy": "コピーする"}}</b-button></span></td>
            </tr>
            <tr>
              <th>{{isChangeEnglish ? "Upload report": "レポートアップロード"}}<span class="require" :class="{requireEnglish: isChangeEnglish}" /></th>
              <td>
                <div class="upload_area" @dragenter="dragEnter">
                  <span class="upload_span">{{isChangeEnglish ? "Drag and drop the analysis data you want to attach here or press Add files": "ここに添付する解析データをドラッグアンドドロップするか、「ファイルを追加」を押します。"}}</span>
                </div>
              </td>
              <b-modal :active.sync="isUpdateModal" has-modal-card  >
                <div class="modal-card uploadModal" 
                  @dragleave="dragLeave"
                  @drop.prevent="fileDorop"
                >
                    {{isChangeEnglish ? "Drop your analysis data files here.": "ここに解析データファイルをドロップします。"}}
                </div>
              </b-modal>
            </tr>
            <tr>
              <th></th>
              <td>                        
                <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple>
                  <span class="file-cta">
                    <span class="file-label">{{isChangeEnglish ? "Add files": "ファイルを追加"}}</span>
                  </span>
                </b-upload>
              </td>
            </tr>
            <tr>
              <th></th>
              <td>
                <table>
                  <template v-for="(preUpfile,index) of preUpFiles">
                    <tr :key="index + 'pre'">
                      <td style="width: 20px"><b-icon icon="paperclip" /></td><td style="width: 430px">{{preUpfile.path}}</td><td><a @click="deleteUpfile(preUpFiles, index)"><b-icon icon="delete-forever-outline " /></a>
                      </td>
                    </tr>
                  </template>
                  <template v-for="(upfile,index) of upFiles">
                    <tr :key="index">
                      <td style="width: 20px"><b-icon icon="paperclip" /></td><td style="width: 430px">{{upfile.path}}</td><td><a @click="deleteUpfile(upFiles, index)"><b-icon icon="delete-forever-outline " /></a>
                      </td>
                    </tr>
                  </template>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" @click="approvalRequest">{{isChangeEnglish ? "Request approval": "承認依頼"}}</b-button>
        </div>
      </div>
      <div style="height:5px;" />
      <div class="labelTitle lable">{{isChangeEnglish ? "Order contents": "申込内容"}}</div>
      <div id="item-contens">
        <holterAnalysisRequestDetail v-if="showDetail" v-bind:data="detailData" :canDownload="true" :editFlag="false" :hstRequestId="data.holterRequestId" :belongsNote="data.belongsNote" :isInternalPsg="true" :isChangeEnglish="isChangeEnglish" :isClipboardCopy="true" />
      </div>
      <div class="button-area">
        <b-button class="receptionistButton is-primary" @click="save">{{isChangeEnglish ? "Update": "更新"}}</b-button>
        <b-button class="backButton is-primary" @click="back">{{isChangeEnglish ? "Back": "戻る"}}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {atLaunchHidden} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import holterAnalysisRequestDetail from "@/components/mock/common/HolterAnalysisRequestDetail";
import {UploadType} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import AnalyistSelectModal from "@/components/mock/philips/common/AnalyistSelectModal";
import {role} from "@/components/mock/base/const.js";
export default {
  name: "HolterAnalysisResultDetail",
  methods: {
    getReceptionData: function() {
      var excuteApi = this.getHolterAnalysisResultDetailPOST;
      var successCallBack = this.getHolterAnalysisResultDetailPOSTSuccess;
      var errorCallBack = this.getHolterAnalysisResultDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterAnalysisResultDetailPOST: function(client) {
      return client.apis.externalHolterAnalysis.getHAnalysisResultDetailExternalPOST({
        body:{receiptNumber: this.receiptNumber}
      });
    },
    getHolterAnalysisResultDetailPOSTSuccess: function(result) {
      this.data = result.obj
      this.data.af = this.data.afKind
      this.uploadFileName = this.data.patientId + "_" + this.data.requestDate + "_" + this.data.hospitalName + "_" + this.data.patientName + "様"
      this.uploadFileName = this.uploadFileName.replace(/[\\/:*?"<>|]/g,'_')
      this.replaceFiles = this.getCopy(this.data.analysisResultFileList);
      if(this.data.cvhri == -1){
        // CVHRI算出不可案件の場合(cvhri=-1)、初期値としてチェックボックス(CVHRI算出不可)をtrue(チェック有)とする
        this.isCvhriNotCalcCheck = true
        this.data.cvhri = null
      }
    },
    getHolterAnalysisResultDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    getDetail: function() {
      var excuteApi = this.getAnalysisDetailPOST;
      var successCallBack = this.getAnalysisDetailPOSTSuccess;
      var errorCallBack = this.getAnalysisDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalHolterAnalysis.getHAnalysisRequestDetailExternalPOST({
        body:{receiptNumber: this.receiptNumber}
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      var res = result.obj
      this.detailData = res.applicationDetails
      this.detailData.patientName = this.detailData.patientName.replace( ' ', '　' );
      this.showDetail = true;
      this.version = res.version;
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    back: function () {
      this.$router.push({
        name: "HolterAnalysisResultGuest",
        params: { searchConditions: this.searchParams, isChangeEnglish:this.isChangeEnglish },
      });
    },
    save: async function () {
      // 承認依頼
      var errMsg = ""
      if (this.upFiles.length!=0 || this.preUpFiles.length != 0) {
        let preNameList = this.preUpFiles.map(item => this.getUploadFileName(item));
        let nameList = this.upFiles.map(item => this.getUploadFileName(item));
        nameList = nameList.concat(preNameList);
        for(let i = 0; i < nameList.length; i++){
          if(nameList[i].startsWith("/")){
            let zipName = nameList[i].replace("/", "");
            nameList[i] = zipName + ".zip"
          }
        }
        const setElements = new Set(nameList);
        if (setElements.size !== nameList.length) {
          if(this.isChangeEnglish){
            errMsg = errMsg + "There are duplicate attached datas.\n"
          } else {
            errMsg = errMsg + "添付データの重複しているファイルが存在します。\n"
          }
        }
        let targetFile = this.upFiles;
        let okSize = await this.checkUploadFileSize(targetFile);
        if(!okSize){
          if(this.isChangeEnglish){
            errMsg = errMsg + "You cannot upload files larger than 2GB.\n"
          } else {
            errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
          }
        }
      }
      if(errMsg) {
        this.showErrorMessage(errMsg)
        return
      }
      //まずはファイルのアップロードから
      this.multipleUpload(this.upFiles ,this.data.receiptNumber, this.UploadType.holter_report)
      .then(reslut =>{
        this.currentUploadFile = reslut;
        var excuteApi = this.setHolterAnalysisTempSavePOST;
        var successCallBack = this.setHolterAnalysisTempSavePOSTSuccess;
        var errorCallBack = this.setHolterAnalysisTempSavePOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      })
      .catch(error =>{
        if(this.isChangeEnglish){
          this.showErrorMessage("Your application has been canceled because the file upload failed.<br>Please try again.");
        } else {
          this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
        }
      });
    },
    setHolterAnalysisTempSavePOST: function(client) {
      var obj = ({
        receiptNumber: this.data.receiptNumber, // 申込みID
        version: this.version, // バージョン
        viewType:"解析結果入力",
        applicationNote:this.detailData.biko, // 依頼内容備考(申送り事項)
        //analysisStaffCode 解析担当者ID
        //analysisDeadline 解析期限
        receptionNote: this.data.note, // 受付備考
        inspectionDate: this.data.inspectionDate ? this.data.inspectionDate.replace(/-/g, "/") : "", // 検査日
        analysisResultNote: this.data.memo,  // 解析結果入力備考
        patientNote: this.detailData.patientBiko, // 患者情報備考
        analysisNote: !this.data.holterRequestId ? this.detailData.analysisDataInfo.biko : "", // 解析データ備考
        cvhri: !this.isCvhriNotCalcCheck ? this.data.cvhri: -1, // CVHRI チェックボックス「CVHRI算出不可=false」:CVHRI入力項目への設定値、「CVHRI算出不可=true」:-1(算出不可)
        afKind: this.data.af,
        isChangeEnglish: this.isChangeEnglish,
      });
      obj.preUpFiles = this.preUpFiles.map(item => item['address']);
      for(let updatedFile of this.currentUploadFile){
        obj.preUpFiles.push(updatedFile.filePath);
      }
      this.currentUploadFile = [];
      return client.apis.externalHolterAnalysis.setHAnalysisTempSaveExternalPOST({
        body:obj
      });
    },
    setHolterAnalysisTempSavePOSTSuccess: function(result) {
      this.showSuccess(result)
      this.getReceptionData()
      this.getDetail()
    },
    setHolterAnalysisTempSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    approvalRequest: async function() {
      // 承認依頼
      // バリデーションチェック
      var errMsg = ""
      var elements = document.getElementsByClassName("edit");
      var result = this.selfMadeValidation(elements);
      if(result.isError) {
        if(this.isChangeEnglish){
          result.msg = result.msg.replace("検査日は必須項目です。","Examination date is require item.")
          result.msg = result.msg.replace("CVHRIは必須項目です。","CVHRI is require item.")
          result.msg = result.msg.replace("CVHRIは整数部3桁小数第1位まで(半角数字,小数点のみ)で入力してください。","Please enter CVHRI as an integer with 3 digits and up to 1 decimal place (single-byte numbers and decimal points only).")
          result.msg = result.msg.replace("AFは必須項目です。","AF Yes/No is require item.")
        }
        errMsg = result.msg
      }
      if (this.upFiles.length==0 && this.preUpFiles.length == 0) {
        if(this.isChangeEnglish){
          errMsg = errMsg + "The attached data is not set.\n"
        } else {
          errMsg = errMsg + "添付データが選択されていません。\n"
        }
      } else {
        let preNameList = this.preUpFiles.map(item => this.getUploadFileName(item));
        let nameList = this.upFiles.map(item => this.getUploadFileName(item));
        nameList = nameList.concat(preNameList);
        for(let i = 0; i < nameList.length; i++){
          if(nameList[i].startsWith("/")){
            let zipName = nameList[i].replace("/", "");
            nameList[i] = zipName + ".zip"
          }
        }
        const setElements = new Set(nameList);
        if (setElements.size !== nameList.length) {
          if(this.isChangeEnglish){
            errMsg = errMsg + "There are duplicate attached datas.\n"
          } else {
            errMsg = errMsg + "添付データの重複しているファイルが存在します。\n"
          }
        }
        let targetFile = this.upFiles;
        let okSize = await this.checkUploadFileSize(targetFile);
        if(!okSize){
          if(this.isChangeEnglish){
            errMsg = errMsg + "You cannot upload files larger than 2GB.\n"
          } else {
            errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
          }
        }
      }
      if(errMsg) {
        this.showErrorMessage(errMsg)
        return
      }

      // ファイル名チェック
      if(!this.checkUploadFileName(this.preUpFiles.concat(this.upFiles))){
        return
      }
      //まずはファイルのアップロードから
      this.multipleUpload(this.upFiles ,this.data.receiptNumber, this.UploadType.holter_report)
      .then(reslut =>{
        this.currentUploadFile = reslut;
        var excuteApi = this.setHolterAnalysisResultApprovalRequestPOST;
        var successCallBack = this.setHolterAnalysisResultApprovalRequestPOSTSuccess;
        var errorCallBack = this.setHolterAnalysisResultApprovalRequestPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      })
      .catch(error =>{
        if(this.isChangeEnglish){
          this.showErrorMessage("Your application has been canceled because the file upload failed.<br>Please try again.");
        } else {
          this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
        }
      });
    },
    setHolterAnalysisResultApprovalRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.inspectionDate = obj.inspectionDate ? obj.inspectionDate.replace(/-/g, "/") : ""
      obj.preUpFiles = this.preUpFiles.map(item => item['address']);
      for(let updatedFile of this.currentUploadFile){
        obj.preUpFiles.push(updatedFile.filePath);
      }
      this.currentUploadFile = [];
      // 申送り事項
      obj.applicationNote = this.detailData.biko
      if(!this.data.holterRequestId){
        // 患者情報備考
        obj.patientNote = this.detailData.patientBiko
        // 解析データ情報備考
        obj.analysisNote = this.detailData.analysisDataInfo.biko
      }
      // CVHRI
      if(this.isCvhriNotCalcCheck){
        // チェックボックス「算出不可」がture(チェック有)の場合、CVHRIのパラメーターとして-1(算出不可)を設定
        obj.cvhri = -1;
      }
      // バージョン
      obj.version = this.version
      return client.apis.externalHolterAnalysis.setHAnalysisResultApprovalRequestExternalPOST({
        body:obj
      });
    },
    setHolterAnalysisResultApprovalRequestPOSTSuccess: function(result) {
      if(this.isChangeEnglish){
        this.showMessage("Your approval request has been accepted.");
      } else {
        this.showMessage("承認依頼を受け付けました。");
      }
      this.back();
    },
    setHolterAnalysisResultApprovalRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      this.isUpdateModal = false;
    },
    fileDorop: async function(event) {
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(entry.isDirectory){
          path = entry.fullPath;
        }
        this.upFiles.push({ file: entry, path: path});
      }
      this.isUpdateModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.upFiles.push({ file: upFile, path: upFile.name});
      }
      this.upButtonFile = [];
    },
    deleteUpfile: function(upFileList, index){
      upFileList.splice(index, 1);
    },
    getUploadFileName: function(uploadItemIfno) {
      if(!uploadItemIfno){
        return ""
      }
      return uploadItemIfno.path || uploadItemIfno.name || (uploadItemIfno.file ? uploadItemIfno.file.name : "")
    },
    checkUploadFileName: function(files) {
      for(let uploadItemIfno of files){
        var name = this.getUploadFileName(uploadItemIfno)
        if(name.indexOf(".") != -1 && name.indexOf(this.uploadFileName) == -1){
          if(this.isChangeEnglish){
            this.showErrorMessage("The medical card ID, application date, medical institution name, and patient name in the attached file may be incorrect.")
          } else {
            this.showErrorMessage("添付したファイルの診察券ID、申込日、医療機関名、患者名が正しくない可能性があります。")
          }
          return false
        }
      }
      return true
    },
    isHolterService: function(){
      if (this.kind == "ホルター心電図配送ｻｰﾋﾞｽ") {
        return true;
      }
      return false;
    },
    clipboardCopy: function(){
      navigator.clipboard.writeText(this.uploadFileName).then(() => {
        if(this.isChangeEnglish){
          this.showMessage('Copied to clipboard.');
        } else {
          this.showMessage('クリップボードにコピーしました。');
        }
      }).catch(err => {
        if(this.isChangeEnglish){
          this.showMessage('Copying failed.');
        } else {
          this.showMessage('コピーに失敗しました');
        }
      });
    },
  },
  data() {
    let analysisMethodList = this.getChoiceList(choicesType.holterMethod, true);
    var item = this.$route.params["item"];
    var receiptNumber = item.receiptNumber;
    var kind = item.kind;
    var version = item.version;
    var reportList = [];
    for (var report of item.reportFileList) {
      reportList.push({ file: report, fileId: report.fileId, path: report.fileName, address: report.fileAddress})
    }
    var searchParams = this.$route.params["searchConditions"];
    var detailData = {analysisDataInfo:{attachedDataFileList:{}}};
    var isChangeEnglish = this.$route.params["isChangeEnglish"];
    return {
      role: role,
      analystId: null,
      data: [],
      UploadType:UploadType,
      receiptNumber: receiptNumber,
      detailData,
      searchParams,
      upFiles: [],
      preUpFiles:reportList,
      upButtonFile:null,
      isUpdateModal: false,
      kind: kind,
      replaceReasonInputModalActive:false,
      reInspectReasonInputModalActive:false,
      currentUploadFile:[],
      showDetail:false,
      version: version,
      replaceFiles: [],
      uploadFileName:"",
      analysisMethodList: analysisMethodList,
      atLaunchHidden: atLaunchHidden,
      isCvhriNotCalcCheck: false,
      isChangeEnglish: isChangeEnglish
    };
  },
  filters: {
    choiceFilter: function(val, list){
      if(!val) return val
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    holterAnalysisRequestDetail: holterAnalysisRequestDetail,
    analyistSelectModal:AnalyistSelectModal,
    reasonInputModal:reasonInputModal,
  },
  mounted: function() {
    // 詳細情報取得
    this.getReceptionData()
    this.getDetail()
  }
};
</script>
<style lang="scss" scoped>
.switch-area {
  display: flex;
}
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
.reject-reason-table {
  border-collapse: collapse;
  table-layout: fixed;
}
.reject-reason-table th {
  padding: 1px 0;
  border: 1px solid;
  text-align: center;
  vertical-align: middle;
}
.reject-reason-table td {
  padding: 1px 0 1px 10px;
  border: 1px solid;
  vertical-align: middle;
}
.reject-reason-table th.reject-date,
.reject-reason-table td.reject-date {
  width: 20% !important;
}
.delay {
  font-weight: bold;
}
.delay,
.error {
  color: red;
  margin-left: 5px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.clipbordcopy {
  margin-left:3%;
  right: 10px;
  width: 100px;
}
.requireEnglish::after { 
  content: "Required" !important
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/HolterAnalysisResultGuestDetail.vue